export default "__VITE_ASSET__D4eNzON9__"